"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.LOCALIZATION_FORMAT = {
    af: { decimal: ',', thousands: '\u00A0' },
    agq: { decimal: ',', thousands: '\u00A0' },
    ar: { decimal: '.', thousands: ',' },
    'ar-mr': { decimal: ',', thousands: '.' },
    arn: { decimal: ',', thousands: '.' },
    ast: { decimal: ',', thousands: '.' },
    az: { decimal: ',', thousands: '.' },
    'az-cyrl': { decimal: ',', thousands: '\u00A0' },
    'az-cyrl-az': { decimal: ',', thousands: '\u00A0' },
    ba: { decimal: ',', thousands: '\u00A0' },
    bas: { decimal: ',', thousands: '\u00A0' },
    be: { decimal: ',', thousands: '\u00A0' },
    bg: { decimal: ',', thousands: '\u00A0' },
    br: { decimal: ',', thousands: '\u00A0' },
    bs: { decimal: ',', thousands: '.' },
    ca: { decimal: ',', thousands: '.' },
    cs: { decimal: ',', thousands: '\u00A0' },
    co: { decimal: ',', thousands: '\u00A0' },
    cu: { decimal: ',', thousands: '\u00A0' },
    da: { decimal: ',', thousands: '.' },
    de: { decimal: ',', thousands: '.' },
    'de-ch': { decimal: '.', thousands: '’' },
    'de-li': { decimal: '.', thousands: '’' },
    dje: { decimal: '.', thousands: '\u00A0' },
    dsb: { decimal: ',', thousands: '.' },
    dua: { decimal: ',', thousands: '\u00A0' },
    dyo: { decimal: ',', thousands: '\u00A0' },
    el: { decimal: ',', thousands: '.' },
    en: { decimal: '.', thousands: ',' },
    'en-150': { decimal: ',', thousands: '.' },
    'en-at': { decimal: ',', thousands: '.' },
    'en-be': { decimal: ',', thousands: '.' },
    'en-ch': { decimal: ',', thousands: '.' },
    'en-de': { decimal: ',', thousands: '.' },
    'en-dk': { decimal: ',', thousands: '.' },
    'en-fi': { decimal: ',', thousands: '\u00A0' },
    'en-id': { decimal: ',', thousands: '.' },
    'en-nl': { decimal: ',', thousands: '.' },
    'en-se': { decimal: ',', thousands: '\u00A0' },
    'en-si': { decimal: ',', thousands: '.' },
    'en-za': { decimal: ',', thousands: '\u00A0' },
    eo: { decimal: ',', thousands: '\u00A0' },
    es: { decimal: ',', thousands: '.' },
    'es-419': { decimal: '.', thousands: ',' },
    'es-br': { decimal: '.', thousands: ',' },
    'es-bz': { decimal: '.', thousands: ',' },
    'es-cu': { decimal: '.', thousands: ',' },
    'es-do': { decimal: '.', thousands: ',' },
    'es-gt': { decimal: '.', thousands: ',' },
    'es-hn': { decimal: '.', thousands: ',' },
    'es-mx': { decimal: '.', thousands: ',' },
    'es-ni': { decimal: '.', thousands: ',' },
    'es-pa': { decimal: '.', thousands: ',' },
    'es-pe': { decimal: '.', thousands: ',' },
    'es-pr': { decimal: '.', thousands: ',' },
    'es-sv': { decimal: '.', thousands: ',' },
    'es-us': { decimal: '.', thousands: ',' },
    et: { decimal: ',', thousands: '\u00A0' },
    eu: { decimal: ',', thousands: '.' },
    ewo: { decimal: ',', thousands: '\u00A0' },
    fa: { decimal: '/', thousands: ',' },
    fi: { decimal: ',', thousands: '\u00A0' },
    ff: { decimal: ',', thousands: '\u00A0' },
    'ff-latn-ng': { decimal: '.', thousands: ',' },
    fo: { decimal: ',', thousands: '.' },
    fr: { decimal: ',', thousands: '\u00A0' },
    'fr-be': { decimal: ',', thousands: '.' },
    'fr-ch': { decimal: '.', thousands: '\u00A0' },
    'fr-lu': { decimal: ',', thousands: '.' },
    'fr-ma': { decimal: ',', thousands: '.' },
    fur: { decimal: ',', thousands: '.' },
    fy: { decimal: ',', thousands: '.' },
    gl: { decimal: ',', thousands: '.' },
    gn: { decimal: ',', thousands: '.' },
    gsw: { decimal: '.', thousands: '’' },
    'gsw-fr': { decimal: ',', thousands: '\u00A0' },
    he: { decimal: '.', thousands: ',' },
    hr: { decimal: ',', thousands: '.' },
    hsb: { decimal: ',', thousands: '.' },
    hu: { decimal: ',', thousands: '\u00A0' },
    ia: { decimal: ',', thousands: '.' },
    id: { decimal: ',', thousands: '.' },
    is: { decimal: ',', thousands: '.' },
    it: { decimal: ',', thousands: '.' },
    'it-ch': { decimal: '.', thousands: '’' },
    ja: { decimal: '.', thousands: ',' },
    jgo: { decimal: ',', thousands: '.' },
    jv: { decimal: ',', thousands: '.' },
    ka: { decimal: ',', thousands: '\u00A0' },
    kab: { decimal: ',', thousands: '\u00A0' },
    kea: { decimal: '$', thousands: '\u00A0' },
    khq: { decimal: '.', thousands: '\u00A0' },
    kk: { decimal: ',', thousands: '\u00A0' },
    kkj: { decimal: ',', thousands: '.' },
    kl: { decimal: ',', thousands: '.' },
    ko: { decimal: '.', thousands: ',' },
    ksf: { decimal: ',', thousands: '\u00A0' },
    ksh: { decimal: ',', thousands: '\u00A0' },
    ky: { decimal: ',', thousands: '\u00A0' },
    lb: { decimal: ',', thousands: '\u00A0' },
    ln: { decimal: ',', thousands: '.' },
    lo: { decimal: ',', thousands: '.' },
    lt: { decimal: ',', thousands: '\u00A0' },
    lu: { decimal: ',', thousands: '.' },
    lv: { decimal: ',', thousands: '\u00A0' },
    mfe: { decimal: '.', thousands: '\u00A0' },
    mgh: { decimal: ',', thousands: '.' },
    mk: { decimal: ',', thousands: '.' },
    mr: { decimal: '`', thousands: ',' },
    ms: { decimal: '.', thousands: ',' },
    'mr-in': { decimal: '`', thousands: ',' },
    'ms-bn': { decimal: ',', thousands: '.' },
    mua: { decimal: ',', thousands: '.' },
    nb: { decimal: ',', thousands: '\u00A0' },
    nds: { decimal: ',', thousands: '.' },
    nl: { decimal: ',', thousands: '.' },
    nmg: { decimal: ',', thousands: '\u00A0' },
    nn: { decimal: ',', thousands: '\u00A0' },
    nnh: { decimal: ',', thousands: '.' },
    no: { decimal: ',', thousands: '\u00A0' },
    nr: { decimal: ',', thousands: '\u00A0' },
    nso: { decimal: '.', thousands: '\u00A0' },
    oc: { decimal: ',', thousands: '\u00A0' },
    os: { decimal: ',', thousands: '\u00A0' },
    pl: { decimal: ',', thousands: '\u00A0' },
    prg: { decimal: ',', thousands: '\u00A0' },
    ps: { decimal: ',', thousands: '.' },
    pt: { decimal: ',', thousands: '.' },
    'pt-ao': { decimal: ',', thousands: '\u00A0' },
    'pt-ch': { decimal: ',', thousands: '\u00A0' },
    'pt-cv': { decimal: '$', thousands: '\u00A0' },
    'pt-gq': { decimal: ',', thousands: '\u00A0' },
    'pt-gw': { decimal: ',', thousands: '\u00A0' },
    'pt-lu': { decimal: ',', thousands: '\u00A0' },
    'pt-mo': { decimal: ',', thousands: '\u00A0' },
    'pt-mz': { decimal: ',', thousands: '\u00A0' },
    'pt-pt': { decimal: ',', thousands: '\u00A0' },
    'pt-st': { decimal: ',', thousands: '\u00A0' },
    'pt-tl': { decimal: ',', thousands: '\u00A0' },
    quz: { decimal: ',', thousands: '.' },
    'quz-pe': { decimal: '.', thousands: ',' },
    ro: { decimal: ',', thousands: '.' },
    rm: { decimal: '.', thousands: '’' },
    rn: { decimal: ',', thousands: '.' },
    ru: { decimal: ',', thousands: '\u00A0' },
    rw: { decimal: ',', thousands: '.' },
    sah: { decimal: ',', thousands: '\u00A0' },
    se: { decimal: ',', thousands: '\u00A0' },
    'se-se': { decimal: ',', thousands: '.' },
    seh: { decimal: ',', thousands: '.' },
    ses: { decimal: '.', thousands: '\u00A0' },
    sg: { decimal: ',', thousands: '.' },
    shi: { decimal: ',', thousands: '\u00A0' },
    sk: { decimal: ',', thousands: '\u00A0' },
    sl: { decimal: ',', thousands: '.' },
    sma: { decimal: ',', thousands: '.' },
    'sma-no': { decimal: ',', thousands: '\u00A0' },
    smj: { decimal: ',', thousands: '.' },
    'smj-no': { decimal: ',', thousands: '\u00A0' },
    smn: { decimal: ',', thousands: '\u00A0' },
    sms: { decimal: ',', thousands: '\u00A0' },
    sq: { decimal: ',', thousands: '\u00A0' },
    sr: { decimal: ',', thousands: '.' },
    ss: { decimal: ',', thousands: '\u00A0' },
    st: { decimal: ',', thousands: '\u00A0' },
    'sw-cd': { decimal: ',', thousands: '.' },
    sv: { decimal: ',', thousands: '\u00A0' },
    tg: { decimal: ',', thousands: '\u00A0' },
    th: { decimal: '.', thousands: ',' },
    tk: { decimal: ',', thousands: '\u00A0' },
    tl: { decimal: '.', thousands: ',' },
    tn: { decimal: '.', thousands: '\u00A0' },
    tr: { decimal: ',', thousands: '.' },
    ts: { decimal: ',', thousands: '\u00A0' },
    tt: { decimal: ',', thousands: '\u00A0' },
    twq: { decimal: '.', thousands: '\u00A0' },
    tzm: { decimal: ',', thousands: '\u00A0' },
    uk: { decimal: ',', thousands: '\u00A0' },
    uz: { decimal: ',', thousands: '\u00A0' },
    'uz-arab': { decimal: ',', thousands: '.' },
    'uz-arab-af': { decimal: ',', thousands: '.' },
    vi: { decimal: ',', thousands: '.' },
    ve: { decimal: ',', thousands: '\u00A0' },
    wae: { decimal: ',', thousands: '’' },
    wal: { decimal: '.', thousands: '’' },
    wo: { decimal: ',', thousands: '\u00A0' },
    xh: { decimal: '.', thousands: '\u00A0' },
    yav: { decimal: ',', thousands: '\u00A0' },
    zh: { decimal: '.', thousands: ',' },
    zgh: { decimal: ',', thousands: '\u00A0' },
};
exports.CURRENCY_CODE_LOCATION = {
    en: types_1.CurrencyLocation.preSpace,
    fr: types_1.CurrencyLocation.postSpace,
    de: types_1.CurrencyLocation.postSpace,
    it: types_1.CurrencyLocation.postSpace,
    es: types_1.CurrencyLocation.postSpace,
    ja: types_1.CurrencyLocation.preSpace,
    ko: types_1.CurrencyLocation.preSpace,
    el: types_1.CurrencyLocation.postSpace,
    ru: types_1.CurrencyLocation.postSpace,
    pt: types_1.CurrencyLocation.postSpace,
    nl: types_1.CurrencyLocation.postSpace,
    th: types_1.CurrencyLocation.preSpace,
    ms: types_1.CurrencyLocation.preSpace,
    vi: types_1.CurrencyLocation.postSpace,
    sv: types_1.CurrencyLocation.postSpace,
    id: types_1.CurrencyLocation.preSpace,
    pl: types_1.CurrencyLocation.postSpace,
    nb: types_1.CurrencyLocation.preSpace,
    da: types_1.CurrencyLocation.postSpace,
    fi: types_1.CurrencyLocation.postSpace,
    cs: types_1.CurrencyLocation.postSpace,
    tr: types_1.CurrencyLocation.postSpace,
    ca: types_1.CurrencyLocation.postSpace,
    hu: types_1.CurrencyLocation.postSpace,
    bg: types_1.CurrencyLocation.postSpace,
    ro: types_1.CurrencyLocation.postSpace,
    sl: types_1.CurrencyLocation.postSpace,
    he: types_1.CurrencyLocation.preSpace,
    ar: types_1.CurrencyLocation.preSpace,
    lt: types_1.CurrencyLocation.postSpace,
    lv: types_1.CurrencyLocation.preSpace,
    hr: types_1.CurrencyLocation.postSpace,
    et: types_1.CurrencyLocation.postSpace,
    uk: types_1.CurrencyLocation.postSpace,
    tl: types_1.CurrencyLocation.preSpace,
    'pt-br': types_1.CurrencyLocation.preSpace,
    'zh-hk': types_1.CurrencyLocation.preSpace,
    'zh-cn': types_1.CurrencyLocation.preSpace,
    'zh-tw': types_1.CurrencyLocation.preSpace,
};
exports.CURRENCY_SYMBOL_LOCATION = {
    en: types_1.CurrencyLocation.pre,
    fr: types_1.CurrencyLocation.postSpace,
    de: types_1.CurrencyLocation.postSpace,
    it: types_1.CurrencyLocation.postSpace,
    es: types_1.CurrencyLocation.postSpace,
    ja: types_1.CurrencyLocation.pre,
    ko: types_1.CurrencyLocation.pre,
    el: types_1.CurrencyLocation.postSpace,
    ru: types_1.CurrencyLocation.postSpace,
    pt: types_1.CurrencyLocation.postSpace,
    nl: types_1.CurrencyLocation.preSpace,
    th: types_1.CurrencyLocation.pre,
    ms: types_1.CurrencyLocation.pre,
    vi: types_1.CurrencyLocation.postSpace,
    sv: types_1.CurrencyLocation.postSpace,
    id: types_1.CurrencyLocation.pre,
    pl: types_1.CurrencyLocation.postSpace,
    nb: types_1.CurrencyLocation.preSpace,
    da: types_1.CurrencyLocation.postSpace,
    fi: types_1.CurrencyLocation.postSpace,
    cs: types_1.CurrencyLocation.postSpace,
    tr: types_1.CurrencyLocation.postSpace,
    ca: types_1.CurrencyLocation.postSpace,
    hu: types_1.CurrencyLocation.postSpace,
    bg: types_1.CurrencyLocation.postSpace,
    ro: types_1.CurrencyLocation.postSpace,
    sl: types_1.CurrencyLocation.postSpace,
    he: types_1.CurrencyLocation.preSpace,
    ar: types_1.CurrencyLocation.preSpace,
    lt: types_1.CurrencyLocation.postSpace,
    lv: types_1.CurrencyLocation.preSpace,
    hr: types_1.CurrencyLocation.postSpace,
    et: types_1.CurrencyLocation.postSpace,
    uk: types_1.CurrencyLocation.postSpace,
    tl: types_1.CurrencyLocation.pre,
    'pt-br': types_1.CurrencyLocation.preSpace,
    'zh-hk': types_1.CurrencyLocation.pre,
    'zh-cn': types_1.CurrencyLocation.pre,
    'zh-tw': types_1.CurrencyLocation.pre,
};
exports.NEGATIVE_SYMBOL_LOCATION_FOR_CURRENCY_SYMBOL = {
    en: types_1.NegativeSignLocation.withCurrency,
    fr: types_1.NegativeSignLocation.withNumber,
    de: types_1.NegativeSignLocation.withNumber,
    it: types_1.NegativeSignLocation.withNumber,
    es: types_1.NegativeSignLocation.withNumber,
    ja: types_1.NegativeSignLocation.withNumber,
    ko: types_1.NegativeSignLocation.withCurrency,
    el: types_1.NegativeSignLocation.withNumber,
    ru: types_1.NegativeSignLocation.withNumber,
    pt: types_1.NegativeSignLocation.withNumber,
    nl: types_1.NegativeSignLocation.withNumber,
    th: types_1.NegativeSignLocation.withCurrency,
    ms: types_1.NegativeSignLocation.withCurrency,
    vi: types_1.NegativeSignLocation.withNumber,
    sv: types_1.NegativeSignLocation.withNumber,
    id: types_1.NegativeSignLocation.withCurrency,
    pl: types_1.NegativeSignLocation.withNumber,
    nb: types_1.NegativeSignLocation.withCurrency,
    da: types_1.NegativeSignLocation.withNumber,
    fi: types_1.NegativeSignLocation.withNumber,
    cs: types_1.NegativeSignLocation.withNumber,
    tr: types_1.NegativeSignLocation.withNumber,
    ca: types_1.NegativeSignLocation.withNumber,
    hu: types_1.NegativeSignLocation.withNumber,
    bg: types_1.NegativeSignLocation.withNumber,
    ro: types_1.NegativeSignLocation.withNumber,
    sl: types_1.NegativeSignLocation.withNumber,
    he: types_1.NegativeSignLocation.afterNumber,
    ar: types_1.NegativeSignLocation.withNumber,
    lt: types_1.NegativeSignLocation.withNumber,
    lv: types_1.NegativeSignLocation.withCurrency,
    hr: types_1.NegativeSignLocation.withNumber,
    et: types_1.NegativeSignLocation.withNumber,
    uk: types_1.NegativeSignLocation.withNumber,
    tl: types_1.NegativeSignLocation.withCurrency,
    'pt-br': types_1.NegativeSignLocation.withCurrency,
    'zh-hk': types_1.NegativeSignLocation.withCurrency,
    'zh-cn': types_1.NegativeSignLocation.withCurrency,
    'zh-tw': types_1.NegativeSignLocation.withCurrency,
};
exports.NEGATIVE_SYMBOL_LOCATION_FOR_CURRENCY_SYMBOL_EXP = __assign({}, exports.NEGATIVE_SYMBOL_LOCATION_FOR_CURRENCY_SYMBOL, { ar: types_1.NegativeSignLocation.afterNumber });
exports.NEGATIVE_SYMBOL_LOCATION_FOR_CURRENCY_CODE = {
    en: types_1.NegativeSignLocation.withCurrency,
    fr: types_1.NegativeSignLocation.withNumber,
    de: types_1.NegativeSignLocation.withNumber,
    it: types_1.NegativeSignLocation.withNumber,
    es: types_1.NegativeSignLocation.withNumber,
    ja: types_1.NegativeSignLocation.withCurrency,
    ko: types_1.NegativeSignLocation.withCurrency,
    el: types_1.NegativeSignLocation.withNumber,
    ru: types_1.NegativeSignLocation.withNumber,
    pt: types_1.NegativeSignLocation.withNumber,
    nl: types_1.NegativeSignLocation.withNumber,
    th: types_1.NegativeSignLocation.withCurrency,
    ms: types_1.NegativeSignLocation.withCurrency,
    vi: types_1.NegativeSignLocation.withNumber,
    sv: types_1.NegativeSignLocation.withNumber,
    id: types_1.NegativeSignLocation.withCurrency,
    pl: types_1.NegativeSignLocation.withNumber,
    nb: types_1.NegativeSignLocation.withCurrency,
    da: types_1.NegativeSignLocation.withNumber,
    fi: types_1.NegativeSignLocation.withNumber,
    cs: types_1.NegativeSignLocation.withNumber,
    tr: types_1.NegativeSignLocation.withNumber,
    ca: types_1.NegativeSignLocation.withNumber,
    hu: types_1.NegativeSignLocation.withNumber,
    bg: types_1.NegativeSignLocation.withNumber,
    ro: types_1.NegativeSignLocation.withNumber,
    sl: types_1.NegativeSignLocation.withNumber,
    he: types_1.NegativeSignLocation.afterNumber,
    ar: types_1.NegativeSignLocation.withNumber,
    lt: types_1.NegativeSignLocation.withNumber,
    lv: types_1.NegativeSignLocation.withCurrency,
    hr: types_1.NegativeSignLocation.withNumber,
    et: types_1.NegativeSignLocation.withNumber,
    uk: types_1.NegativeSignLocation.withNumber,
    tl: types_1.NegativeSignLocation.withCurrency,
    'pt-br': types_1.NegativeSignLocation.withCurrency,
    'zh-hk': types_1.NegativeSignLocation.withCurrency,
    'zh-cn': types_1.NegativeSignLocation.withCurrency,
    'zh-tw': types_1.NegativeSignLocation.withCurrency,
};
var DECIMAL_POINTS = {
    NO_DECIMAL: 0,
    WITH_DECIMAL: 2,
};
exports.DEFAULT_DECIMAL_DIGIT = {
    eur: DECIMAL_POINTS.WITH_DECIMAL,
    gbp: DECIMAL_POINTS.WITH_DECIMAL,
    hkd: DECIMAL_POINTS.WITH_DECIMAL,
    myr: DECIMAL_POINTS.WITH_DECIMAL,
    sgd: DECIMAL_POINTS.WITH_DECIMAL,
    thb: DECIMAL_POINTS.WITH_DECIMAL,
    usd: DECIMAL_POINTS.WITH_DECIMAL,
    nzd: DECIMAL_POINTS.WITH_DECIMAL,
    aud: DECIMAL_POINTS.WITH_DECIMAL,
    jpy: DECIMAL_POINTS.NO_DECIMAL,
    zar: DECIMAL_POINTS.WITH_DECIMAL,
    cad: DECIMAL_POINTS.WITH_DECIMAL,
    aed: DECIMAL_POINTS.WITH_DECIMAL,
    rmb: DECIMAL_POINTS.WITH_DECIMAL,
    php: DECIMAL_POINTS.WITH_DECIMAL,
    chf: DECIMAL_POINTS.WITH_DECIMAL,
    dkk: DECIMAL_POINTS.WITH_DECIMAL,
    sek: DECIMAL_POINTS.WITH_DECIMAL,
    czk: DECIMAL_POINTS.WITH_DECIMAL,
    pln: DECIMAL_POINTS.WITH_DECIMAL,
    brl: DECIMAL_POINTS.WITH_DECIMAL,
    idr: DECIMAL_POINTS.NO_DECIMAL,
    krw: DECIMAL_POINTS.NO_DECIMAL,
    inr: DECIMAL_POINTS.WITH_DECIMAL,
    twd: DECIMAL_POINTS.WITH_DECIMAL,
    nok: DECIMAL_POINTS.WITH_DECIMAL,
    omr: DECIMAL_POINTS.WITH_DECIMAL,
    fjd: DECIMAL_POINTS.WITH_DECIMAL,
    bhd: DECIMAL_POINTS.WITH_DECIMAL,
    ars: DECIMAL_POINTS.WITH_DECIMAL,
    bgn: DECIMAL_POINTS.WITH_DECIMAL,
    xpf: DECIMAL_POINTS.NO_DECIMAL,
    vnd: DECIMAL_POINTS.NO_DECIMAL,
    egp: DECIMAL_POINTS.WITH_DECIMAL,
    huf: DECIMAL_POINTS.WITH_DECIMAL,
    uah: DECIMAL_POINTS.WITH_DECIMAL,
    jod: DECIMAL_POINTS.WITH_DECIMAL,
    lak: DECIMAL_POINTS.WITH_DECIMAL,
    kwd: DECIMAL_POINTS.WITH_DECIMAL,
    mxn: DECIMAL_POINTS.WITH_DECIMAL,
    ngn: DECIMAL_POINTS.WITH_DECIMAL,
    ils: DECIMAL_POINTS.WITH_DECIMAL,
    ron: DECIMAL_POINTS.WITH_DECIMAL,
    pkr: DECIMAL_POINTS.WITH_DECIMAL,
    qar: DECIMAL_POINTS.WITH_DECIMAL,
    khr: DECIMAL_POINTS.WITH_DECIMAL,
    mvr: DECIMAL_POINTS.WITH_DECIMAL,
    rub: DECIMAL_POINTS.WITH_DECIMAL,
    sar: DECIMAL_POINTS.WITH_DECIMAL,
    lkr: DECIMAL_POINTS.WITH_DECIMAL,
    bdt: DECIMAL_POINTS.WITH_DECIMAL,
    kzt: DECIMAL_POINTS.WITH_DECIMAL,
    try: DECIMAL_POINTS.WITH_DECIMAL,
};
//# sourceMappingURL=configurations.js.map